export default function getEntityApiServiceName(entityName: string) {
  return (
    entityName.charAt(0).toUpperCase() + entityName.slice(1) + 'ApiService'
  );
}
